import { render, staticRenderFns } from "./ExamVideoSlot.vue?vue&type=template&id=ecaa3c58&scoped=true&"
import script from "./ExamVideoSlot.vue?vue&type=script&lang=js&"
export * from "./ExamVideoSlot.vue?vue&type=script&lang=js&"
import style0 from "./ExamVideoSlot.vue?vue&type=style&index=0&id=ecaa3c58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecaa3c58",
  null
  
)

export default component.exports